import React from 'react';
import InProgressOrdersList from '../OrdersList/variants/InProgressOrdersList';
import PendingOrdersList from '../OrdersList/variants/PendingOrdersList';
import CompletedOrdersList from '../OrdersList/variants/CompletedOrdersList';
import DeclinedOrdersList from '../OrdersList/variants/DeclinedOrdersList';

import s from './OrdersByStatusPageContent.scss';

const OrdersByStatusPageContent: React.FC = () => {
  return (
    <div className={s['root']}>
      <PendingOrdersList />
      <InProgressOrdersList />
      <CompletedOrdersList />
      <DeclinedOrdersList />
    </div>
  );
};
OrdersByStatusPageContent.displayName = 'OrdersByStatusPageContent';

export default OrdersByStatusPageContent;
